import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE } from './api-constants';
import { UserDetail, UpdateUserRequest } from '../../models/user.model';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  constructor(private http: HttpClient) {}

  listUsers(): Observable<UserDetail[]> {
    return this.http.get<UserDetail[]>(`${API_BASE}/users/list`);
  }

  getUserDetail(id: number): Observable<UserDetail> {
    return this.http.get<UserDetail>(`${API_BASE}/users/${id}/detail`);
  }

  registerUser(req: { name: string; email: string; password: string }): Observable<UserDetail> {
    return this.http.post<UserDetail>(`${API_BASE}/users/register`, req);
  }

  updateUser(id: number, req: UpdateUserRequest): Observable<UserDetail> {
    return this.http.put<UserDetail>(`${API_BASE}/users/${id}/detail`, req);
  }

  deactivateUser(id: number): Observable<{ message: string }> {
    return this.http.patch<{ message: string }>(`${API_BASE}/users/${id}/deactivate`, {});
  }

  reactivateUser(id: number): Observable<{ message: string }> {
    return this.http.patch<{ message: string }>(`${API_BASE}/users/${id}/reactivate`, {});
  }

  getGroups(): Observable<{ id: number; name: string }[]> {
    return this.http.get<{ id: number; name: string }[]>(`${API_BASE}/groups/get-all?page=0&size=100`);
  }
}
